module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"searchPlaceholder":"Encontrar páginas, automações ou tabelas"},"en":{"searchPlaceholder":"Find pages, workflows or sheets"}}')
  delete Component.options._Ctor
}
